import React from 'react';
import {
    arrayOf,
    oneOfType,
    string,
    func,
    element,
    bool,
    node,
} from 'prop-types';
import {
    Modal,
    ModalControl,
    ModalContent,
    ModalHeader,
    ModalBody,
    Overlay,
    CrossIcon,
    Title,
} from '@paygreen/paygreen-ui';
import { ErrorBoundary } from '..';

import ModalControlClose from './ModalControlClose';
/**
 * @description - this component needs absolutely to have <ModalProvider/> as a parent (direct or indirect) to receive modal context and to have ModalControl working to open/close the modal. It is made to use modal 'inside' a component without being obligatory its child
 */
const ModalForm = ({
    blockWidth,
    children,
    hasCloseCross,
    modalTitle,
    paddingLateral,
    onClose,
    textSize,
    titleColor,
}) => (
    <ModalControl>
        <Modal>
            <ModalControl>
                <ModalControlClose action={onClose}>
                    <Overlay gradient="theme" opacityValue={60} />
                </ModalControlClose>
            </ModalControl>

            <ModalContent blockWidth={blockWidth}>
                {modalTitle || hasCloseCross ? (
                    <ModalHeader
                        paddingLateral={paddingLateral}
                        paddingTop="sm"
                    >
                        {modalTitle ? (
                            <Title textSize={textSize} colorWab={titleColor}>
                                {modalTitle}
                            </Title>
                        ) : null}

                        {hasCloseCross ? (
                            <ModalControl>
                                <ModalControlClose action={onClose}>
                                    <CrossIcon
                                        htmlTag="button"
                                        iconSize="md"
                                        colorPallet="wab"
                                    />
                                </ModalControlClose>
                            </ModalControl>
                        ) : null}
                    </ModalHeader>
                ) : null}

                <ModalBody
                    paddingTop={modalTitle || hasCloseCross ? 'none' : 'sm'}
                    paddingBottom="sm"
                    paddingLateral={paddingLateral}
                >
                    <ErrorBoundary>{children}</ErrorBoundary>
                </ModalBody>
            </ModalContent>
        </Modal>
    </ModalControl>
);

ModalForm.propTypes = {
    blockWidth: string,
    modalTitle: string,
    children: oneOfType([element, arrayOf(element), node]),
    hasCloseCross: bool,
    paddingLateral: string,
    onClose: func,
    textSize: string,
    customIcon: string,
    titleColor: string,
};

ModalForm.defaultProps = {
    blockWidth: 'sm',
    modalTitle: '',
    hasCloseCross: true,
    paddingLateral: 'xs',
    children: null,
    onClose: null,
    textSize: 'md',
    customIcon: 'CrossIcon',
    titleColor: 'grey40',
};

export default ModalForm;
